import { Component, Prop, Emit, Vue, toNative } from 'vue-facing-decorator';

@Component({
    name: 'HeaderCard'
})
class HeaderCard extends Vue {
    //is_loading
    @Prop({ type: Boolean, default: true }) is_loading!: boolean;
    //title
    @Prop({ type: String, default: '' }) title!: string;
    //icon
    @Prop({ type: String, default: '🏥' }) icon!: string;
    //subtitle
    @Prop({ type: String, default: 'INSTALASI GIZI RSUD dr. Soeroto Ngawi' }) subtitle!: string;

    // ===== Props =====
    @Prop({ type: Boolean, default: false }) clickable!: boolean;
    @Prop({ type: String, default: '' }) route!: string;

    // ===== Events =====
    @Emit('click')
    handleClick() {
        if (this.clickable && this.route) {
            this.$router.push(this.route);
        }
        // Mengembalikan data untuk event click
        return {
            route: this.route,
            title: this.title,
            icon: this.icon
        };
    }

    // ===== Additional Event =====
    @Emit('header-click')
    handleHeaderClick() {
        return {
            route: this.route,
            title: this.title,
            icon: this.icon
        };
    }
}

export default toNative(HeaderCard);